import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AgentFormHint } from './agent.service';

export interface AiHintState {
  hint: string;
  severity: 'info' | 'warning' | 'error';
  field: string;
  loading: boolean;
}

@Injectable({ providedIn: 'root' })
export class AiHintStateService {
  private _state$ = new BehaviorSubject<AiHintState>({
    hint: '', severity: 'info', field: '', loading: false
  });
  private _collapse$ = new Subject<void>();

  readonly state$ = this._state$.asObservable();
  readonly collapse$ = this._collapse$.asObservable();

  setLoading(field: string): void {
    this._state$.next({ ...this._state$.value, field, loading: true, hint: '' });
  }

  setHint(field: string, result: AgentFormHint): void {
    // No applicable validation rule for this field — show nothing.
    if (result?.severity === 'none' || !result?.hint?.trim()) {
      this._state$.next({ hint: '', severity: 'info', field, loading: false });
      return;
    }
    this._state$.next({
      hint: result.hint,
      severity: result.severity as 'info' | 'warning' | 'error',
      field,
      loading: false
    });
  }

  clearLoading(): void {
    this._state$.next({ ...this._state$.value, loading: false });
  }

  clear(): void {
    this._state$.next({ hint: '', severity: 'info', field: '', loading: false });
  }

  collapse(): void {
    this._state$.next({ hint: '', severity: 'info', field: '', loading: false });
    this._collapse$.next();
  }
}
